import { AppPermissions } from 'constants/permissions';
import { permissions as prodManagerPermissions } from '../ProductionManager/permissions';

export const permissions = {
  ...prodManagerPermissions,
  viewTransaction: [AppPermissions.change_payment, AppPermissions.add_payment],
};
